import React from "react";

const SegmentedControl = ({
  options,
  value,
  onChange,
  ariaLabel,
  disabled = false,
  // Icon-only, for tight spots like the profile dropdown. Labels stay in the
  // accessible name rather than being dropped.
  compact = false,
  className = "",
}) => (
  <div
    role="radiogroup"
    aria-label={ariaLabel}
    className={`inline-flex items-center gap-0.5 rounded-lg border border-ui-border bg-ui-surface-sunken p-0.5 ${className}`}
  >
    {options.map(({ value: optionValue, label, icon: Icon }) => {
      const isActive = value === optionValue;

      return (
        <button
          key={optionValue}
          type="button"
          role="radio"
          aria-checked={isActive}
          aria-label={compact ? label : undefined}
          title={label}
          disabled={disabled}
          onClick={() => onChange(optionValue)}
          className={`flex items-center justify-center gap-1.5 rounded-md py-1 text-xs font-medium transition-colors disabled:opacity-60 disabled:cursor-not-allowed ${
            compact ? "px-1.5" : "px-2"
          } ${
            isActive
              ? "bg-ui-surface text-brand shadow-ui-sm"
              : "text-ui-text-muted hover:text-brand"
          }`}
        >
          {Icon && <Icon className="h-3.5 w-3.5 shrink-0" />}
          {!compact && <span>{label}</span>}
        </button>
      );
    })}
  </div>
);

export default SegmentedControl;
